import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { Props as BaseEntityLinkProps } from "shared/components/common/base-entity-link";

import {
  HeaderAllMenuItemBaseLink,
  HeaderAllMenuItemLinkContainer,
  HeaderAllMenuTitle,
} from "scmp-app/components/header/header-oneline-menu-container/header-all-menu/common";
import type { headerAllMenuSectionAppConfigQuery$key } from "scmp-app/queries/__generated__/headerAllMenuSectionAppConfigQuery.graphql";

import { ItemContainer, StyledIconPostmag, StyledIconStyle } from "./styles";

export type Props = {
  queryParameter: BaseEntityLinkProps["query"];
  reference: headerAllMenuSectionAppConfigQuery$key;
};

export const HeaderAllMenuSection: FunctionComponent<Props> = ({ queryParameter, reference }) => {
  const appConfig = useFragment(
    graphql`
      fragment headerAllMenuSectionAppConfigQuery on Query {
        onelineMenu: appConfig(filter: { entityId: "scmp_pwa_oneline_menu" }) {
          json
        }
      }
    `,
    reference,
  );

  const onelineMenuAppConfig = appConfig?.onelineMenu?.json as ScmpPwaOnelineMenuAppConfig;
  const allList = onelineMenuAppConfig?.all;
  if (!allList) return null;

  const renderLinkLabel = (link: OnelineMenuItem) => {
    if (link.entityId === "71") return <StyledIconPostmag />;
    if (link.entityId === "72") return <StyledIconStyle />;
    return link.name;
  };

  return (
    <>
      {allList.map((listItem, index) => (
        <ItemContainer key={index}>
          <HeaderAllMenuTitle>{listItem.name}</HeaderAllMenuTitle>
          <HeaderAllMenuItemLinkContainer>
            {listItem.items.map((link, index) => (
              <HeaderAllMenuItemBaseLink
                key={index}
                linkEntity={link}
                query={queryParameter}
                target={link.isNewTab ? "_blank" : undefined}
              >
                {renderLinkLabel(link)}
              </HeaderAllMenuItemBaseLink>
            ))}
          </HeaderAllMenuItemLinkContainer>
        </ItemContainer>
      ))}
    </>
  );
};

HeaderAllMenuSection.displayName = "HeaderAllMenuSection";
